(function () {
  "use strict";

  var CFG    = window.RETURNS_CONFIG || {};
  var API    = CFG.apiBase  || "";
  var SK     = CFG.stripeKey || "";
  var locale = (CFG.locale  || "en").toLowerCase().split("-")[0];

  // ── i18n ────────────────────────────────────────────────────────────────────
  var T = {
    es: {
      title:          "Cambios y devoluciones",
      subtitle:       "Gestiona tu cambio de talla o solicitud de devolución",
      step1:          "Pedido",
      step2:          "Artículos",
      step3:          "Pago",
      step4:          "Confirmación",
      orderNum:       "Número de pedido",
      orderNumHint:   "Lo encuentras en tu email de confirmación. Empieza con #",
      emailOrPhone:   "Código postal",
      findOrder:      "BUSCAR PEDIDO",
      searching:      "Buscando...",
      selectItems:    "Selecciona los artículos",
      selectItemsHint:"Elige qué quieres devolver o cambiar de talla/color",
      actionReturn:   "Devolver",
      actionExchange: "Cambio Talla/Color/Correa",
      recommended:    "Recomendado",
      returnFeeNote:  "⚠️ Además, los gastos de envío del pedido original tampoco serán reembolsados.",
      reason:         "Motivo",
      reasons: {
        wrong_size:    "Talla incorrecta",
        too_small:     "Me queda pequeño",
        too_large:     "Me queda grande",
        wrong_color:   "Color incorrecto",
        defective:     "Producto defectuoso",
        not_as_described: "No es como en la foto",
        changed_mind:  "He cambiado de opinión",
        other:         "Otro motivo",
      },
      newSize:        "Nueva talla (opcional)",
      newColor:       "Nuevo color (opcional)",
      sameColor:      "Sin cambio de color",
      optional:       "opcional",
      noChange:       "Sin cambio de talla",
      continue:       "CONTINUAR",
      back:           "Volver",
      summary:        "Resumen de tu solicitud",
      shipping:       "Gastos de envío de devolución",
      shippingNote:   "Esta tarifa cubre el envío de Correos para tu devolución.",
      payAndSubmit:   "PAGAR Y ENVIAR SOLICITUD",
      processing:     "Procesando...",
      confirmTitle:   "¡Solicitud enviada!",
      confirmRef:     "Referencia: ",
      confirmStep1:   "Revisa tu email",
      confirmStep1b:  "Te hemos enviado un email de confirmación con los detalles.",
      confirmStep2:   "Tu etiqueta está lista",
      confirmStep2b:  "Descárgala ahora usando el botón de abajo.",
      confirmStep2Pending: "Recibirás tu etiqueta",
      confirmStep2bPending: "En un plazo de 24h hábiles recibirás por email tu etiqueta de Correos.",
      downloadLabel:  "⬇ DESCARGAR ETIQUETA DE CORREOS",
      trackingLabel:  "Nº de seguimiento:",
      confirmStep3:   "Pega la etiqueta y entrega el paquete",
      confirmStep3b:  "Lleva el paquete a cualquier oficina de Correos o buzón autorizado.",
      confirmStep4Ex: "Tu pedido de cambio está en preparación",
      confirmStep4bEx:"Recibirás un email cuando tu nuevo pedido esté enviado.",
      newSearch:      "Nueva solicitud",
      err_notFound:   "No encontramos ningún pedido con esos datos. Revisa el número y el email.",
      err_window:     "El plazo de devolución ({n} días) ha expirado. Si tienes dudas, contacta con nosotros.",
      err_notFulfilled: "Tu pedido aún está en preparación. Solo puedes solicitar cambios o devoluciones una vez recibido.",
      err_noItems:    "Selecciona al menos un artículo.",
      err_noAction:   "Indica si quieres devolver o cambiar cada artículo seleccionado.",
      err_noReason:   "Indica el motivo de cada artículo.",
      err_noNewVariant: "Selecciona la nueva talla para los artículos de cambio.",
      err_payment:    "Error al procesar el pago. Inténtalo de nuevo.",
      err_server:     "Error de servidor. Inténtalo de nuevo.",
      err_fields:     "Por favor, rellena todos los campos.",
      labelReturn:    "Devolución",
      labelExchange:  "Cambio",
      feeEU:          "Envío Correos — Paq Return",
      feeIntl:        "Envío Correos — Paq Return International",
    },
    en: {
      title:          "Returns & Exchanges",
      subtitle:       "Manage your size exchange or refund request",
      step1:          "Order",
      step2:          "Items",
      step3:          "Payment",
      step4:          "Done",
      orderNum:       "Order number",
      orderNumHint:   "Found in your confirmation email. Starts with #",
      emailOrPhone:   "Postal code",
      findOrder:      "FIND MY ORDER",
      searching:      "Searching...",
      selectItems:    "Select items",
      selectItemsHint:"Choose what you want to return or exchange",
      actionReturn:   "Return for refund",
      actionExchange: "Exchange Size/Color/Lead",
      recommended:    "Recommended",
      returnFeeNote:  "⚠️ Please note that the original shipping costs will not be refunded either.",
      reason:         "Reason",
      reasons: {
        wrong_size:    "Wrong size",
        too_small:     "Too small",
        too_large:     "Too large",
        wrong_color:   "Wrong color",
        defective:     "Defective product",
        not_as_described: "Not as described",
        changed_mind:  "Changed my mind",
        other:         "Other",
      },
      newSize:        "New size (optional)",
      newColor:       "New color (optional)",
      sameColor:      "No color exchange",
      optional:       "optional",
      noChange:       "No size change",
      continue:       "CONTINUE",
      back:           "Back",
      summary:        "Request summary",
      shipping:       "Return shipping cost",
      shippingNote:   "This fee covers Correos return shipping.",
      payAndSubmit:   "PAY & SUBMIT REQUEST",
      processing:     "Processing...",
      confirmTitle:   "Request submitted!",
      confirmRef:     "Reference: ",
      confirmStep1:   "Check your email",
      confirmStep1b:  "We've sent you a confirmation email with all the details.",
      confirmStep2:   "Your label is ready",
      confirmStep2b:  "Download it now using the button below.",
      confirmStep2Pending: "You'll receive your label",
      confirmStep2bPending: "Within 24 business hours you'll receive your Correos return label by email.",
      downloadLabel:  "⬇ DOWNLOAD CORREOS LABEL",
      trackingLabel:  "Tracking number:",
      confirmStep3:   "Stick the label and drop off your parcel",
      confirmStep3b:  "Take your package to any Correos post office or authorised drop-off point.",
      confirmStep4Ex: "Your exchange order is being prepared",
      confirmStep4bEx:"You'll get an email once your new order ships.",
      newSearch:      "New request",
      err_notFound:   "No order found with those details. Check your order number and email.",
      err_window:     "The return window ({n} days) has expired. Please contact us if you have questions.",
      err_notFulfilled: "Your order is still being prepared. You can only request returns or exchanges after receiving it.",
      err_noItems:    "Please select at least one item.",
      err_noAction:   "Select return or exchange for each selected item.",
      err_noReason:   "Please select a reason for each item.",
      err_noNewVariant: "Please select the new size for exchange items.",
      err_payment:    "Payment error. Please try again.",
      err_server:     "Server error. Please try again.",
      err_fields:     "Please fill in all fields.",
      labelReturn:    "Return",
      labelExchange:  "Exchange",
      feeEU:          "Correos shipping — Paq Return",
      feeIntl:        "Correos shipping — Paq Return International",
    },
    fr: {
      title:          "Retours et échanges",
      subtitle:       "Gérez votre échange de taille ou votre demande de remboursement",
      step1:          "Commande",
      step2:          "Articles",
      step3:          "Paiement",
      step4:          "Confirmation",
      orderNum:       "Numéro de commande",
      orderNumHint:   "Disponible dans votre email de confirmation. Commence par #",
      emailOrPhone:   "Code postal",
      findOrder:      "TROUVER MA COMMANDE",
      searching:      "Recherche...",
      selectItems:    "Sélectionnez les articles",
      selectItemsHint:"Choisissez ce que vous souhaitez retourner ou échanger",
      actionReturn:   "Retourner",
      actionExchange: "Changer Taille/Couleur/Laisse",
      recommended:    "Recommandé",
      returnFeeNote:  "⚠️ Les frais d'expédition de la commande originale ne seront pas non plus remboursés.",
      reason:         "Motif",
      reasons: {
        wrong_size:    "Mauvaise taille",
        too_small:     "Trop petit",
        too_large:     "Trop grand",
        wrong_color:   "Mauvaise couleur",
        defective:     "Produit défectueux",
        not_as_described: "Non conforme à la description",
        changed_mind:  "J'ai changé d'avis",
        other:         "Autre",
      },
      newSize:        "Nouvelle taille (optionnel)",
      newColor:       "Nouvelle couleur (optionnel)",
      sameColor:      "Pas de changement de couleur",
      optional:       "optionnel",
      noChange:       "Sans changement de taille",
      continue:       "CONTINUER",
      back:           "Retour",
      summary:        "Récapitulatif de votre demande",
      shipping:       "Frais de retour",
      shippingNote:   "Ces frais couvrent l'envoi Correos pour votre retour.",
      payAndSubmit:   "PAYER ET ENVOYER LA DEMANDE",
      processing:     "Traitement...",
      confirmTitle:   "Demande envoyée !",
      confirmRef:     "Référence : ",
      confirmStep1:   "Vérifiez votre email",
      confirmStep1b:  "Nous vous avons envoyé un email de confirmation.",
      confirmStep2:   "Votre étiquette est prête",
      confirmStep2b:  "Téléchargez-la maintenant avec le bouton ci-dessous.",
      confirmStep2Pending: "Vous recevrez votre étiquette",
      confirmStep2bPending: "Sous 24h ouvrées, vous recevrez votre étiquette Correos par email.",
      downloadLabel:  "⬇ TÉLÉCHARGER L'ÉTIQUETTE CORREOS",
      trackingLabel:  "Numéro de suivi :",
      confirmStep3:   "Collez l'étiquette et déposez le colis",
      confirmStep3b:  "Déposez votre colis dans un bureau de poste Correos.",
      confirmStep4Ex: "Votre commande d'échange est en préparation",
      confirmStep4bEx:"Vous recevrez un email dès l'expédition de votre nouvelle commande.",
      newSearch:      "Nouvelle demande",
      err_notFound:   "Aucune commande trouvée. Vérifiez le numéro et l'email.",
      err_window:     "Le délai de retour ({n} jours) est expiré.",
      err_notFulfilled: "Votre commande est encore en préparation.",
      err_noItems:    "Sélectionnez au moins un article.",
      err_noAction:   "Indiquez l'action pour chaque article.",
      err_noReason:   "Indiquez le motif pour chaque article.",
      err_noNewVariant: "Sélectionnez la nouvelle taille pour les échanges.",
      err_payment:    "Erreur de paiement. Réessayez.",
      err_server:     "Erreur serveur. Réessayez.",
      err_fields:     "Veuillez remplir tous les champs.",
      labelReturn:    "Retour",
      labelExchange:  "Échange",
      feeEU:          "Livraison Correos — Paq Return",
      feeIntl:        "Livraison Correos — Paq Return International",
    },
    pt: {
      title:          "Trocas e devoluções",
      subtitle:       "Gere a sua troca de tamanho ou pedido de devolução",
      step1:          "Pedido",
      step2:          "Artigos",
      step3:          "Pagamento",
      step4:          "Confirmação",
      orderNum:       "Número do pedido",
      orderNumHint:   "Encontras no email de confirmação. Começa por #",
      emailOrPhone:   "Código postal",
      findOrder:      "ENCONTRAR PEDIDO",
      searching:      "A procurar...",
      selectItems:    "Seleciona os artigos",
      selectItemsHint:"Escolhe o que queres devolver ou trocar",
      actionReturn:   "Devolver",
      actionExchange: "Troca Tamanho/Cor/Trela",
      recommended:    "Recomendado",
      returnFeeNote:  "⚠️ Além disso, os custos de envio do pedido original também não serão reembolsados.",
      reason:         "Motivo",
      reasons: {
        wrong_size:    "Tamanho errado",
        too_small:     "Muito pequeno",
        too_large:     "Muito grande",
        wrong_color:   "Cor errada",
        defective:     "Produto com defeito",
        not_as_described: "Não corresponde à descrição",
        changed_mind:  "Mudei de ideias",
        other:         "Outro",
      },
      newSize:        "Novo tamanho (opcional)",
      newColor:       "Nova cor (opcional)",
      sameColor:      "Sem troca de cor",
      optional:       "opcional",
      noChange:       "Sem alteração de tamanho",
      continue:       "CONTINUAR",
      back:           "Voltar",
      summary:        "Resumo do pedido",
      shipping:       "Custo de envio de devolução",
      shippingNote:   "Esta taxa cobre o envio Correos para a tua devolução.",
      payAndSubmit:   "PAGAR E ENVIAR PEDIDO",
      processing:     "A processar...",
      confirmTitle:   "Pedido enviado!",
      confirmRef:     "Referência: ",
      confirmStep1:   "Verifica o teu email",
      confirmStep1b:  "Enviámos um email de confirmação com todos os detalhes.",
      confirmStep2:   "A tua etiqueta está pronta",
      confirmStep2b:  "Descarrega-a agora com o botão abaixo.",
      confirmStep2Pending: "Receberás a tua etiqueta",
      confirmStep2bPending: "Em 24h úteis receberás a etiqueta Correos por email.",
      downloadLabel:  "⬇ DESCARREGAR ETIQUETA CORREOS",
      trackingLabel:  "Nº de rastreio:",
      confirmStep3:   "Cola a etiqueta e entrega o pacote",
      confirmStep3b:  "Leva o teu pacote a um escritório dos Correios.",
      confirmStep4Ex: "O teu pedido de troca está a ser preparado",
      confirmStep4bEx:"Receberás um email quando o teu novo pedido for enviado.",
      newSearch:      "Novo pedido",
      err_notFound:   "Nenhum pedido encontrado. Verifica o número e o email.",
      err_window:     "O prazo de devolução ({n} dias) expirou.",
      err_notFulfilled: "O teu pedido ainda está em preparação.",
      err_noItems:    "Seleciona pelo menos um artigo.",
      err_noAction:   "Indica a ação para cada artigo.",
      err_noReason:   "Indica o motivo para cada artigo.",
      err_noNewVariant: "Seleciona o novo tamanho para as trocas.",
      err_payment:    "Erro no pagamento. Tenta de novo.",
      err_server:     "Erro no servidor. Tenta de novo.",
      err_fields:     "Preenche todos os campos.",
      labelReturn:    "Devolução",
      labelExchange:  "Troca",
      feeEU:          "Envio Correos — Paq Return",
      feeIntl:        "Envio Correos — Paq Return International",
    },
    de: {
      title:          "Rücksendungen & Umtausch",
      subtitle:       "Verwalte deinen Größentausch oder deine Rückgabe",
      step1:          "Bestellung",
      step2:          "Artikel",
      step3:          "Zahlung",
      step4:          "Bestätigung",
      orderNum:       "Bestellnummer",
      orderNumHint:   "In deiner Bestätigungs-E-Mail. Beginnt mit #",
      emailOrPhone:   "Postleitzahl",
      findOrder:      "BESTELLUNG SUCHEN",
      searching:      "Suche...",
      selectItems:    "Artikel auswählen",
      selectItemsHint:"Wähle aus, was du zurücksenden oder umtauschen möchtest",
      actionReturn:   "Zurücksenden",
      actionExchange: "Größe/Farbe/Leine tauschen",
      recommended:    "Empfohlen",
      returnFeeNote:  "⚠️ Außerdem werden die Versandkosten der ursprünglichen Bestellung ebenfalls nicht erstattet.",
      reason:         "Grund",
      reasons: {
        wrong_size:    "Falsche Größe",
        too_small:     "Zu klein",
        too_large:     "Zu groß",
        wrong_color:   "Falsche Farbe",
        defective:     "Defektes Produkt",
        not_as_described: "Nicht wie beschrieben",
        changed_mind:  "Meinung geändert",
        other:         "Sonstiges",
      },
      newSize:        "Neue Größe (optional)",
      newColor:       "Neue Farbe (optional)",
      sameColor:      "Keine Farbänderung",
      optional:       "optional",
      noChange:       "Keine Größenänderung",
      continue:       "WEITER",
      back:           "Zurück",
      summary:        "Zusammenfassung deiner Anfrage",
      shipping:       "Rücksendekosten",
      shippingNote:   "Diese Gebühr deckt den Correos-Versand für deine Rücksendung.",
      payAndSubmit:   "BEZAHLEN UND SENDEN",
      processing:     "Verarbeitung...",
      confirmTitle:   "Anfrage gesendet!",
      confirmRef:     "Referenz: ",
      confirmStep1:   "Prüfe deine E-Mail",
      confirmStep1b:  "Wir haben dir eine Bestätigungs-E-Mail gesendet.",
      confirmStep2:   "Dein Etikett ist fertig",
      confirmStep2b:  "Lade es jetzt mit dem Button unten herunter.",
      confirmStep2Pending: "Du erhältst dein Etikett",
      confirmStep2bPending: "Innerhalb von 24 Wertstunden erhältst du dein Correos-Label per E-Mail.",
      downloadLabel:  "⬇ CORREOS-ETIKETT HERUNTERLADEN",
      trackingLabel:  "Sendungsnummer:",
      confirmStep3:   "Etikett aufkleben und Paket abgeben",
      confirmStep3b:  "Bringe dein Paket zu einer Correos-Filiale.",
      confirmStep4Ex: "Deine Umtauschbestellung wird vorbereitet",
      confirmStep4bEx:"Du erhältst eine E-Mail, sobald deine neue Bestellung versendet wird.",
      newSearch:      "Neue Anfrage",
      err_notFound:   "Keine Bestellung gefunden. Überprüfe die Nummer und die E-Mail.",
      err_window:     "Die Rückgabefrist ({n} Tage) ist abgelaufen.",
      err_notFulfilled: "Deine Bestellung wird noch vorbereitet.",
      err_noItems:    "Wähle mindestens einen Artikel aus.",
      err_noAction:   "Wähle eine Aktion für jeden ausgewählten Artikel.",
      err_noReason:   "Wähle einen Grund für jeden Artikel.",
      err_noNewVariant: "Wähle die neue Größe für Umtauschartikel.",
      err_payment:    "Zahlungsfehler. Bitte versuche es erneut.",
      err_server:     "Serverfehler. Bitte versuche es erneut.",
      err_fields:     "Bitte alle Felder ausfüllen.",
      labelReturn:    "Rücksendung",
      labelExchange:  "Umtausch",
      feeEU:          "Versand Correos — Paq Return",
      feeIntl:        "Versand Correos — Paq Return International",
    },
    it: {
      title:          "Resi e cambi",
      subtitle:       "Gestisci il cambio taglia o la tua richiesta di reso",
      step1:          "Ordine",
      step2:          "Articoli",
      step3:          "Pagamento",
      step4:          "Conferma",
      orderNum:       "Numero ordine",
      orderNumHint:   "Disponibile nella tua email di conferma. Inizia con #",
      emailOrPhone:   "Codice postale",
      findOrder:      "CERCA ORDINE",
      searching:      "Ricerca...",
      selectItems:    "Seleziona gli articoli",
      selectItemsHint:"Scegli cosa vuoi restituire o cambiare",
      actionReturn:   "Restituire",
      actionExchange: "Cambio Taglia/Colore/Guinzaglio",
      recommended:    "Consigliato",
      returnFeeNote:  "⚠️ Inoltre, anche le spese di spedizione dell'ordine originale non verranno rimborsate.",
      reason:         "Motivo",
      reasons: {
        wrong_size:    "Taglia errata",
        too_small:     "Troppo piccolo",
        too_large:     "Troppo grande",
        wrong_color:   "Colore errato",
        defective:     "Prodotto difettoso",
        not_as_described: "Non come descritto",
        changed_mind:  "Ho cambiato idea",
        other:         "Altro",
      },
      newSize:        "Nuova taglia (opzionale)",
      newColor:       "Nuovo colore (opzionale)",
      sameColor:      "Nessun cambio colore",
      optional:       "opzionale",
      noChange:       "Nessun cambio taglia",
      continue:       "CONTINUA",
      back:           "Indietro",
      summary:        "Riepilogo della richiesta",
      shipping:       "Costo di spedizione reso",
      shippingNote:   "Questa tariffa copre la spedizione Correos per il tuo reso.",
      payAndSubmit:   "PAGA E INVIA RICHIESTA",
      processing:     "Elaborazione...",
      confirmTitle:   "Richiesta inviata!",
      confirmRef:     "Riferimento: ",
      confirmStep1:   "Controlla la tua email",
      confirmStep1b:  "Ti abbiamo inviato un'email di conferma.",
      confirmStep2:   "La tua etichetta è pronta",
      confirmStep2b:  "Scaricala ora con il pulsante qui sotto.",
      confirmStep2Pending: "Riceverai la tua etichetta",
      confirmStep2bPending: "Entro 24 ore lavorative riceverai la tua etichetta Correos per email.",
      downloadLabel:  "⬇ SCARICA ETICHETTA CORREOS",
      trackingLabel:  "Numero di tracciamento:",
      confirmStep3:   "Incolla l'etichetta e consegna il pacco",
      confirmStep3b:  "Porta il tuo pacco a qualsiasi ufficio Correos.",
      confirmStep4Ex: "Il tuo ordine di cambio è in preparazione",
      confirmStep4bEx:"Riceverai un'email quando il tuo nuovo ordine verrà spedito.",
      newSearch:      "Nuova richiesta",
      err_notFound:   "Nessun ordine trovato. Controlla il numero e l'email.",
      err_window:     "Il periodo di reso ({n} giorni) è scaduto.",
      err_notFulfilled: "Il tuo ordine è ancora in preparazione.",
      err_noItems:    "Seleziona almeno un articolo.",
      err_noAction:   "Indica l'azione per ogni articolo selezionato.",
      err_noReason:   "Indica il motivo per ogni articolo.",
      err_noNewVariant: "Seleziona la nuova taglia per i cambi.",
      err_payment:    "Errore di pagamento. Riprova.",
      err_server:     "Errore del server. Riprova.",
      err_fields:     "Compila tutti i campi.",
      labelReturn:    "Reso",
      labelExchange:  "Cambio",
      feeEU:          "Spedizione Correos — Paq Return",
      feeIntl:        "Spedizione Correos — Paq Return International",
    },
  };

  function t(key, vars) {
    var lang = T[locale] || T.en;
    var str  = lang[key] !== undefined ? lang[key] : (T.en[key] || key);
    if (vars) {
      for (var k in vars) str = str.replace("{" + k + "}", vars[k]);
    }
    return str;
  }

  function tr(reasonKey) {
    var lang = T[locale] || T.en;
    return (lang.reasons && lang.reasons[reasonKey]) || (T.en.reasons[reasonKey] || reasonKey);
  }

  // ── State ────────────────────────────────────────────────────────────────────
  var state = {
    step:          1,
    order:         null,
    items:         [],   // [{...lineItem, selected, action, reason, newVariantId, newSize, newColor}]
    returnId:      null,
    clientSecret:  null,
    feeCents:      0,
    stripe:        null,
    elements:      null,
  };

  // ── DOM refs ─────────────────────────────────────────────────────────────────
  var $steps  = document.getElementById("rp-steps");
  var $panels = document.getElementById("rp-panels");
  var $banner = document.getElementById("rp-banner");

  // ── Utilities ────────────────────────────────────────────────────────────────
  function showBanner(type, msg) {
    $banner.className = "rp-banner rp-banner--" + type;
    $banner.innerHTML = msg;
    $banner.style.display = "block";
    $banner.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function hideBanner() {
    $banner.style.display = "none";
  }

  function fmtAmount(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function post(endpoint, payload) {
    return fetch(API + endpoint, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify(payload),
    }).then(function (r) {
      if (!r.ok) console.error("[API " + endpoint + "] HTTP " + r.status);
      return r.json();
    });
  }

  // ── Step rendering ───────────────────────────────────────────────────────────
  function setStep(n) {
    state.step = n;
    hideBanner();

    // Progress dots
    var dots  = $steps.querySelectorAll(".rp-step-dot");
    var lines = $steps.querySelectorAll(".rp-step-line");
    dots.forEach(function (d, i) {
      d.className = "rp-step-dot" + (i + 1 < n ? " done" : i + 1 === n ? " active" : "");
    });
    lines.forEach(function (l, i) {
      l.className = "rp-step-line" + (i + 1 < n ? " done" : "");
    });

    // Panels
    $panels.querySelectorAll(".rp-panel").forEach(function (p) {
      p.style.display = p.dataset.step === String(n) ? "block" : "none";
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // ── Step 1 : Order lookup ────────────────────────────────────────────────────
  function initStep1() {
    var $form  = document.getElementById("rp-s1-form");
    var $num   = document.getElementById("rp-s1-num");
    var $email = document.getElementById("rp-s1-email");
    var $btn   = document.getElementById("rp-s1-btn");

    $btn.textContent = t("findOrder");

    $form.addEventListener("submit", function (e) {
      e.preventDefault();
      var num   = $num.value.trim();
      var zip   = $email.value.trim();
      if (!num || !zip) { showBanner("error", t("err_fields")); return; }

      $btn.disabled    = true;
      $btn.textContent = t("searching");
      hideBanner();

      post("/api/returns-lookup", { orderNumber: num, postalCode: zip, locale: locale })
        .then(function (data) {
          if (data.error === "order_not_found") {
            showBanner("error", t("err_notFound"));
          } else if (data.error === "outside_return_window") {
            showBanner("error", t("err_window", { n: data.windowDays }));
          } else if (data.error === "not_fulfilled") {
            showBanner("info", t("err_notFulfilled"));
          } else if (data.error) {
            showBanner("error", t("err_server"));
          } else {
            state.order = data;
            state.items = (data.lineItems || []).map(function (li) {
              return Object.assign({}, li, { selected: false, action: null, reason: "", newVariantId: null, newSize: null, newColor: null });
            });
            renderStep2();
            setStep(2);
          }
        })
        .catch(function () { showBanner("error", t("err_server")); })
        .finally(function () {
          $btn.disabled    = false;
          $btn.textContent = t("findOrder");
        });
    });
  }

  // ── Step 2 : Item selection ──────────────────────────────────────────────────
  function renderStep2() {
    var $panel = $panels.querySelector('[data-step="2"]');
    $panel.querySelector(".rp-step-heading").textContent = t("selectItems");
    $panel.querySelector(".rp-step-subheading").textContent = t("selectItemsHint");

    var $list = document.getElementById("rp-s2-items");
    $list.innerHTML = "";

    var isSpain2      = (state.order.countryCode || "ES") === "ES";
    var priceReturn   = isSpain2 ? "9,99 €" : "13,29 €";
    var priceExchange = isSpain2 ? "5,81 €" : "9,99 €";

    state.items.forEach(function (item, idx) {
      var variantLabel = (item.selectedOptions || []).map(function (o) { return o.name + ": " + o.value; }).join(" / ");

      // Build size options
      var sizeOpts = "";
      var sizeVariants = item.variants || [];
      if (sizeVariants.length > 0) {
        sizeOpts = '<option value="">' + t("noChange") + '</option>';
        sizeVariants.forEach(function (v) {
          sizeOpts += '<option value="' + v.id + '">' + v.title + '</option>';
        });
      }

      // Build color options
      var colorOpts = '<option value="">' + t("sameColor") + '</option>';
      var COLOR_LIST = ["Navy Blue","Baby Blue","Tiffany Blue","Forest Green","Matcha Green","Honey Yellow","Chocolate Brown","Passion Red","Pale Pink","Lavander Lilac","Light Grey","Pirate Black"];
      COLOR_LIST.forEach(function (c) {
        colorOpts += '<option value="' + c + '">' + c + '</option>';
      });

      // Build reason options
      var reasonKeys = ["wrong_size","too_small","too_large","wrong_color","defective","not_as_described","changed_mind","other"];
      var reasonOpts = '<option value="">' + t("reason") + '</option>';
      reasonKeys.forEach(function (k) {
        reasonOpts += '<option value="' + k + '">' + tr(k) + '</option>';
      });

      var imgHtml = item.imageUrl
        ? '<img class="rp-item-img" src="' + item.imageUrl + '" alt="' + item.name + '" loading="lazy">'
        : '<div class="rp-item-img-placeholder">🐶</div>';

      // Build one selector per Shopify option dimension (Size, Correa, etc.)
      var OPTION_NAME_I18N = {
        "Talla":  { es: "Talla",   en: "Size",  fr: "Taille",   pt: "Tamanho", de: "Größe",   it: "Taglia" },
        "Correa": { es: "Correa",  en: "Lead",  fr: "Laisse",   pt: "Trela",   de: "Leine",   it: "Guinzaglio" },
      };
      var OPTION_VALUE_I18N = {
        "Clásica (1.80m)":     "Regular (1.80m)",
        "Manos Libres (1.80m)": "Hands-Free (1.80m)",
      };
      function tOpt(name) {
        var map = OPTION_NAME_I18N[name];
        return map ? (map[locale] || map["en"] || name) : name;
      }
      function tOptVal(val) {
        return OPTION_VALUE_I18N[val] || val;
      }

      var optionNames = [];
      if (sizeVariants.length > 0 && sizeVariants[0].options) {
        sizeVariants[0].options.forEach(function(o) { optionNames.push(o.name); });
      }

      var exchangeFields = "";
      if (optionNames.length > 1) {
        // Multi-option product: one dropdown per option
        optionNames.forEach(function(optName) {
          var uniqueVals = [];
          sizeVariants.forEach(function(v) {
            var opt = (v.options || []).find(function(o){ return o.name === optName; });
            if (opt && uniqueVals.indexOf(opt.value) === -1) uniqueVals.push(opt.value);
          });
          exchangeFields += '<div class="rp-exchange-label">' + tOpt(optName) + ' <span style="font-weight:400;color:#9ca3af">('+t("optional")+')</span></div>';
          exchangeFields += '<select class="rp-option-sel" data-idx="' + idx + '" data-opt="' + optName + '">';
          exchangeFields += '<option value="">' + t("noChange") + '</option>';
          uniqueVals.forEach(function(val) {
            exchangeFields += '<option value="' + val + '">' + tOptVal(val) + '</option>';
          });
          exchangeFields += '</select>';
        });
      } else if (sizeVariants.length > 0) {
        // Single-option product
        exchangeFields = '<div class="rp-exchange-label">' + t("newSize") + '</div><select class="rp-size-sel" data-idx="' + idx + '"><option value="">' + t("noChange") + '</option>' + sizeVariants.map(function(v){ return '<option value="' + v.id + '">' + v.title + '</option>'; }).join("") + '</select>';
      }
      exchangeFields += '<div class="rp-exchange-label">' + t("newColor") + '</div><select class="rp-color-sel" data-idx="' + idx + '">' + colorOpts + '</select>';

      var html = [
        '<div class="rp-item" data-idx="' + idx + '">',
          '<div class="rp-item-header">',
            '<input type="checkbox" class="rp-item-check" data-idx="' + idx + '">',
            imgHtml,
            '<div class="rp-item-info">',
              '<div class="rp-item-name">' + item.name + '</div>',
              variantLabel ? '<div class="rp-item-variant">' + variantLabel + '</div>' : "",
            '</div>',
          '</div>',
          '<div class="rp-item-options" data-idx="' + idx + '">',
            '<div class="rp-action-pills">',
              '<button type="button" class="rp-pill rp-pill-return" data-idx="' + idx + '">',
                t("actionReturn"),
                '<span class="rp-pill-price">' + priceReturn + '</span>',
              '</button>',
              '<div class="rp-pill-recommended-wrap">',
                '<span class="rp-recommended-badge">' + t("recommended") + '</span>',
                '<button type="button" class="rp-pill rp-pill-exchange" data-idx="' + idx + '">',
                  t("actionExchange"),
                  '<span class="rp-pill-price">' + priceExchange + '</span>',
                '</button>',
              '</div>',
            '</div>',
            '<select class="rp-reason-sel" data-idx="' + idx + '" style="display:none">' + reasonOpts + '</select>',
            '<p class="rp-return-fee-note" data-idx="' + idx + '" style="display:none">' + t("returnFeeNote") + '</p>',
            '<div class="rp-exchange-fields" data-idx="' + idx + '">',
              exchangeFields,
            '</div>',
          '</div>',
        '</div>',
      ].join("");

      $list.insertAdjacentHTML("beforeend", html);
    });

    // Wire up events
    $list.querySelectorAll(".rp-item-check").forEach(function (cb) {
      cb.addEventListener("change", function () {
        var idx  = parseInt(cb.dataset.idx);
        state.items[idx].selected = cb.checked;
        var $itemEl = $list.querySelector('.rp-item[data-idx="' + idx + '"]');
        var $opts   = $list.querySelector('.rp-item-options[data-idx="' + idx + '"]');
        if (cb.checked) {
          $itemEl.classList.add("selected");
          $opts.classList.add("visible");
        } else {
          $itemEl.classList.remove("selected");
          $opts.classList.remove("visible");
          state.items[idx].action = null;
          state.items[idx].reason = "";
          state.items[idx].newVariantId = null;
          state.items[idx].newSize  = null;
          state.items[idx].newColor = null;
        }
      });
    });

    $list.querySelectorAll(".rp-pill-return").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.dataset.idx);
        state.items[idx].action = "return";
        var $pills = $list.querySelectorAll('.rp-pill[data-idx="' + idx + '"]');
        $pills.forEach(function(p){ p.classList.remove("active"); });
        btn.classList.add("active");
        var $exF = $list.querySelector('.rp-exchange-fields[data-idx="' + idx + '"]');
        $exF.classList.remove("visible");
        var $reason = $list.querySelector('.rp-reason-sel[data-idx="' + idx + '"]');
        $reason.style.display = "";
        var $note = $list.querySelector('.rp-return-fee-note[data-idx="' + idx + '"]');
        if ($note) $note.style.display = "";
      });
    });

    $list.querySelectorAll(".rp-pill-exchange").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.dataset.idx);
        state.items[idx].action = "exchange";
        state.items[idx].reason = "exchange";
        var $pills = $list.querySelectorAll('.rp-pill[data-idx="' + idx + '"]');
        $pills.forEach(function(p){ p.classList.remove("active"); });
        btn.classList.add("active");
        var $exF = $list.querySelector('.rp-exchange-fields[data-idx="' + idx + '"]');
        $exF.classList.add("visible");
        var $reason = $list.querySelector('.rp-reason-sel[data-idx="' + idx + '"]');
        $reason.style.display = "none";
        var $note = $list.querySelector('.rp-return-fee-note[data-idx="' + idx + '"]');
        if ($note) $note.style.display = "none";
      });
    });

    $list.querySelectorAll(".rp-reason-sel").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var idx = parseInt(sel.dataset.idx);
        state.items[idx].reason = sel.value;
      });
    });

    $list.querySelectorAll(".rp-size-sel").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var idx  = parseInt(sel.dataset.idx);
        var varId = sel.value;
        state.items[idx].newVariantId = varId || null;
        if (varId) {
          var v = (state.items[idx].variants || []).find(function(v){ return v.id === varId; });
          state.items[idx].newSize = v ? v.title : null;
        } else {
          state.items[idx].newSize = null;
          state.items[idx].newVariantId = state.items[idx].variantId;
        }
      });
    });

    // Multi-option selectors — resolve variant from combination of selected option values
    function resolveVariantFromOptions(idx) {
      var item = state.items[idx];
      var $sels = $list.querySelectorAll('.rp-option-sel[data-idx="' + idx + '"]');
      var chosen = {};
      $sels.forEach(function(s) {
        if (s.value) {
          chosen[s.dataset.opt] = s.value;
        } else {
          // No change selected — keep original value for this option
          var origOpt = (item.selectedOptions || []).find(function(o) { return o.name === s.dataset.opt; });
          if (origOpt) chosen[s.dataset.opt] = origOpt.value;
        }
      });
      if (!Object.keys(chosen).length) { item.newVariantId = null; item.newSize = null; return; }

      var match = (item.variants || []).find(function(v) {
        return Object.keys(chosen).every(function(optName) {
          var opt = (v.options || []).find(function(o){ return o.name === optName; });
          return opt && opt.value === chosen[optName];
        });
      });
      item.newVariantId = match ? match.id : null;
      item.newSize = match ? match.title : Object.values(chosen).join(" / ");
    }

    $list.querySelectorAll(".rp-option-sel").forEach(function (sel) {
      sel.addEventListener("change", function () {
        resolveVariantFromOptions(parseInt(sel.dataset.idx));
      });
    });

    $list.querySelectorAll(".rp-color-sel").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var idx = parseInt(sel.dataset.idx);
        state.items[idx].newColor = sel.value || null;
      });
    });

    // Continue button
    var $btn = document.getElementById("rp-s2-btn");
    $btn.textContent = t("continue");

    $btn.onclick = function () {
      var selected = state.items.filter(function (i) { return i.selected; });
      if (!selected.length) { showBanner("error", t("err_noItems")); return; }
      var noAction = selected.some(function (i) { return !i.action; });
      if (noAction) { showBanner("error", t("err_noAction")); return; }
      var noReason = selected.some(function (i) { return i.action === "return" && !i.reason; });
      if (noReason) { showBanner("error", t("err_noReason")); return; }
      var noVariant = selected.some(function (i) {
        if (i.action !== "exchange") return false;
        return false; // size and color are optional for exchange
      });
      if (noVariant) { showBanner("error", t("err_noNewVariant")); return; }

      renderStep3();
      setStep(3);
    };

    // Back button
    document.getElementById("rp-s2-back").textContent = t("back");
    document.getElementById("rp-s2-back").onclick = function () { setStep(1); };
  }

  // ── Step 3 : Summary + Payment ───────────────────────────────────────────────
  function renderStep3() {
    var selected   = state.items.filter(function (i) { return i.selected; });
    var isSpain    = (state.order.countryCode || "ES") === "ES";
    var hasReturn  = selected.some(function (i) { return i.action === "return"; });
    var feeCents   = isSpain
      ? (hasReturn ? 999 : 581)
      : (hasReturn ? 1329 : 999);
    state.feeCents = feeCents;

    // Summary items
    var summaryHtml = selected.map(function (item) {
      var badge = item.action === "return"
        ? '<span class="rp-summary-badge rp-badge-return">' + t("labelReturn") + '</span>'
        : '<span class="rp-summary-badge rp-badge-exchange">' + t("labelExchange") + '</span>';

      var detail = "";
      if (item.action === "exchange") {
        if (item.newSize) detail += t("newSize") + ": " + item.newSize + " ";
        if (item.newColor) detail += t("newColor").replace(" (opcional)","").replace(" (optional)","").replace(" (optionnel)","").replace(" (optional)","").replace(" (opzionale)","").replace(" (opcional)","") + ": " + item.newColor;
      }

      var img = item.imageUrl
        ? '<img class="rp-summary-img" src="' + item.imageUrl + '" alt="" loading="lazy">'
        : '<div class="rp-summary-img" style="background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:1.2rem">🐶</div>';

      return [
        '<div class="rp-summary-item">',
          img,
          '<div class="rp-summary-info">',
            '<div class="rp-summary-name">' + item.name + ' ' + badge + '</div>',
            detail ? '<div class="rp-summary-detail">' + detail.trim() + '</div>' : "",
            '<div class="rp-summary-detail">' + tr(item.reason) + '</div>',
          '</div>',
        '</div>',
      ].join("");
    }).join("");

    document.getElementById("rp-s3-items").innerHTML = summaryHtml;

    var feeLabel = isSpain ? t("feeEU") : t("feeIntl");
    document.getElementById("rp-s3-fee-label").textContent  = feeLabel;
    document.getElementById("rp-s3-fee-amount").textContent = fmtAmount(feeCents);
    document.getElementById("rp-s3-fee-note").textContent   = t("shippingNote");
    document.getElementById("rp-s3-summary-title").textContent = t("summary");

    // Stripe Checkout redirect
    var $payBtn  = document.getElementById("rp-s3-btn");
    var $backBtn = document.getElementById("rp-s3-back");
    $payBtn.textContent  = t("payAndSubmit");
    $payBtn.style.display = "";
    $backBtn.textContent = t("back");
    $backBtn.onclick     = function () { setStep(2); };

    $payBtn.disabled = false;

    var itemsPayload = selected.map(function (item) {
      return {
        id:            item.id,
        name:          item.name,
        imageUrl:      item.imageUrl,
        variantId:     item.variantId,
        productHandle: item.productHandle,
        quantity:      item.quantity,
        action:        item.action,
        reason:        item.reason,
        newVariantId:  item.newVariantId || item.variantId,
        newSize:       item.newSize,
        newColor:      item.newColor,
      };
    });

    $payBtn.onclick = function () {
      $payBtn.disabled    = true;
      $payBtn.textContent = t("processing");
      hideBanner();

      post("/api/returns-init", {
        orderId:         state.order.orderId,
        orderNumber:     state.order.orderNumber,
        customerEmail:   state.order.customerEmail,
        customerName:    state.order.customerName,
        countryCode:     state.order.countryCode,
        shippingAddress: state.order.shippingAddress || null,
        items:           itemsPayload,
        successUrl:      window.location.href.split("?")[0],
        cancelUrl:       window.location.href.split("?")[0],
      }).then(function (data) {
        if (data.error || !data.checkoutUrl) {
          showBanner("error", t("err_server"));
          $payBtn.disabled    = false;
          $payBtn.textContent = t("payAndSubmit");
          return;
        }
        state.returnId = data.returnId;
        window.location.href = data.checkoutUrl;
      }).catch(function () {
        showBanner("error", t("err_server"));
        $payBtn.disabled    = false;
        $payBtn.textContent = t("payAndSubmit");
      });
    };
  }

  // ── Step 4 : Confirmation ─────────────────────────────────────────────────────
  function renderStep4(confirmData) {
    var selected    = state.items.filter(function (i) { return i.selected; });
    var hasExchange = selected.some(function (i) { return i.action === "exchange"; });
    var labelReady  = confirmData && confirmData.labelReady;
    var labelUrl    = confirmData && confirmData.labelUrl;
    var tracking    = confirmData && confirmData.trackingNumber;

    document.getElementById("rp-s4-title").textContent = t("confirmTitle");
    document.getElementById("rp-s4-ref").textContent   = t("confirmRef") + (state.returnId || "").slice(0, 8).toUpperCase();

    // If label is ready: show download button prominently before the steps
    var downloadHtml = "";
    if (labelReady && labelUrl) {
      downloadHtml = [
        '<div style="text-align:center;margin-bottom:24px;">',
          '<a href="' + labelUrl + '" target="_blank" download',
            ' style="display:inline-block;padding:14px 24px;background:#111;color:#fff;text-decoration:none;',
            'border-radius:8px;font-weight:700;font-size:0.95rem;letter-spacing:0.04em;margin-bottom:8px;">',
            t("downloadLabel"),
          '</a>',
          tracking ? '<div style="font-size:0.8rem;color:#6b7280;margin-top:6px;">' + t("trackingLabel") + ' <strong>' + tracking + '</strong></div>' : "",
        '</div>',
      ].join("");
    }

    var step2Title = labelReady ? t("confirmStep2")        : t("confirmStep2Pending");
    var step2Body  = labelReady ? t("confirmStep2b")       : t("confirmStep2bPending");

    var stepsHtml = [
      step4Block(1, t("confirmStep1"),  t("confirmStep1b")),
      step4Block(2, step2Title, step2Body),
      step4Block(3, t("confirmStep3"),  t("confirmStep3b")),
    ];
    if (hasExchange) {
      stepsHtml.push(step4Block(4, t("confirmStep4Ex"), t("confirmStep4bEx")));
    }

    document.getElementById("rp-s4-steps").innerHTML = downloadHtml + stepsHtml.join("");
    document.getElementById("rp-s4-new").textContent = t("newSearch");
    document.getElementById("rp-s4-new").onclick = function () {
      state.order   = null;
      state.items   = [];
      state.returnId = null;
      document.getElementById("rp-s1-num").value   = "";
      document.getElementById("rp-s1-email").value = "";
      setStep(1);
    };
  }

  function step4Block(n, strong, text) {
    return [
      '<div class="rp-confirm-step">',
        '<div class="rp-confirm-step-num">' + n + '</div>',
        '<div class="rp-confirm-step-text"><strong>' + strong + '</strong><span>' + text + '</span></div>',
      '</div>',
    ].join("");
  }

  // ── Stripe Checkout return ───────────────────────────────────────────────────
  // Handle redirect back from Stripe Checkout with ?session_id=...&return_id=...
  function checkStripeReturn() {
    var params    = new URLSearchParams(window.location.search);
    var sessionId = params.get("session_id");
    var returnId  = params.get("return_id");
    if (!sessionId || !returnId) return false;

    state.returnId = returnId;

    // Clean URL
    window.history.replaceState({}, "", window.location.pathname);

    setStep(3);
    document.getElementById("rp-s3-btn").disabled    = true;
    document.getElementById("rp-s3-btn").textContent = t("processing");

    post("/api/returns-confirm", { returnId: returnId, sessionId: sessionId })
      .then(function (data) {
        if (data.error) { showBanner("error", t("err_server")); return; }
        renderStep4(data);
        setStep(4);
      })
      .catch(function () { showBanner("error", t("err_server")); });

    return true;
  }

  // ── Boot ─────────────────────────────────────────────────────────────────────
  function boot() {
    // Render i18n static text
    document.getElementById("rp-main-title").textContent = t("title");
    document.getElementById("rp-main-subtitle").textContent = t("subtitle");

    // Step labels
    var stepLabels = ["step1","step2","step3","step4"];
    $steps.querySelectorAll(".rp-step-dot").forEach(function(d, i){
      d.setAttribute("title", t(stepLabels[i]));
    });

    // Labels for step 1
    document.querySelector('label[for="rp-s1-num"]').textContent   = t("orderNum");
    document.querySelector('label[for="rp-s1-email"]').textContent = t("emailOrPhone");
    document.getElementById("rp-s1-num-hint").textContent          = t("orderNumHint");
    document.getElementById("rp-s1-btn").textContent               = t("findOrder");

    if (!checkStripeReturn()) {
      setStep(1);
    }

    initStep1();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();